import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContractConcession } from '@classes/contract-concession';
import { ContractConcessionDetail } from '@classes/contract-concession-detail';
import { ContractType } from '@enums/contract-type.enum';
import { ContractConcessionService } from 'app/core/services/contract-concession.service';
import { DefaultPriceService } from 'app/core/services/default-price.service';
import { IndexService } from 'app/core/services/index.service';
import { UiService } from 'app/core/services/ui.service';
import * as _moment from 'moment';
const moment = _moment;
@Component({
  selector: 'app-contract-concession',
  templateUrl: './contract-concession.component.html',
  styleUrls: ['./contract-concession.component.scss']
})
export class ContractConcessionComponent implements OnInit {

  contractConcessionForm: FormGroup;
  indexPrice = 0;

  ContractType = ContractType;

  currentPrice: number | undefined = 0;
  currentPriceIndex: number | undefined = 0;
  currentCoef: number | undefined = 0;

  constructor(
    private formBuilder: FormBuilder,
    public uiService: UiService,
    private contractConcessionService: ContractConcessionService,
    public dialogRef: MatDialogRef<ContractConcessionComponent>,
    private defaultPriceService: DefaultPriceService,
    private indexService: IndexService,
    @Inject(MAT_DIALOG_DATA) public data?: ContractConcessionDetail
  ) { }

  ngOnInit() {
    this.initFormBuilder(this.data?.contractConcession);
  }

  private initFormBuilder(value?: ContractConcession) {
    var editMode = !(this.data?.isEditMode || this.data?.isCreationMode);
    const fb = this.formBuilder;
    this.contractConcessionForm = fb.group({
      id: fb.control(value?.id),
      contractId: fb.control(value?.contractId || this.data?.contract?.id),
      area: fb.control({ value: value?.area, disabled: editMode }, [Validators.required]),
      startDate: fb.control({ value: value?.startDate, disabled: editMode }, [Validators.required]),
      price: fb.control({ value: value?.price, disabled: editMode }, [Validators.required]),
      percentageDiscount: fb.control({ value: value?.percentageDiscount, disabled: editMode }, [Validators.required]),
      zone: fb.control({ value: value?.zone, disabled: editMode }, []),
      isFittedOutArea: fb.control({ value: value?.isFittedOutArea != null ? ((value?.isFittedOutArea || value?.isFittedOutArea == "true") ? "true" : "false") : null, disabled: editMode }, []),
      isGoodAccessibility: fb.control({ value: value?.isGoodAccessibility != null ? ((value?.isGoodAccessibility || value?.isGoodAccessibility == "true") ? "true" : "false") : null, disabled: editMode }, []),
    });
    this.indexPrice = (value?.price || 0) * (this.indexService.currentCoef?.value || 1);
    this.currentCoef = this.indexService.currentCoef?.value || 1;
    this.contractConcessionForm.controls.price.valueChanges.subscribe(value => {
      this.indexPrice = value * (this.indexService.currentCoef?.value || 1);
    });

    this.getDefaultAnnualFee();

    this.contractConcessionForm.controls.zone.valueChanges.subscribe(value => {
      this.getDefaultAnnualFee();
    });
    this.contractConcessionForm.controls.isFittedOutArea.valueChanges.subscribe(value => {
      this.getDefaultAnnualFee();
    });
    this.contractConcessionForm.controls.isGoodAccessibility.valueChanges.subscribe(value => {
      this.getDefaultAnnualFee();
    });
  }

  private getDefaultAnnualFee() {
    if (this.contractConcessionForm.controls.zone.value
      && this.contractConcessionForm.controls.isFittedOutArea.value
      && this.contractConcessionForm.controls.isGoodAccessibility.value) {
      this.uiService.addRouteLoading();
      this.defaultPriceService.getDefaultAnnualFee().subscribe(data => {
        const defaultPrice = data.find(f =>
          f.isFittedOutArea == (this.contractConcessionForm.controls.isFittedOutArea.value == "true")
          && f.isGoodAccessibility == (this.contractConcessionForm.controls.isGoodAccessibility.value == "true"));
        if (defaultPrice != null) {
          switch (this.contractConcessionForm.controls.zone.value?.toLowerCase()) {
            case "a":
              this.currentPrice = (defaultPrice.priceZoneA || 0);
              this.currentPriceIndex = (defaultPrice.priceZoneA || 0) * (this.indexService.currentCoef?.value || 1);
              break
            case "b":
              this.currentPrice = (defaultPrice.priceZoneB || 0);
              this.currentPriceIndex = (defaultPrice.priceZoneB || 0) * (this.indexService.currentCoef?.value || 1);
              break
          }
        }
        this.uiService.removeRouteLoading();
      }, error => {
        console.error(error);
        this.uiService.removeRouteLoading();
      });
    }
  }

  onSubmit() {
    this.uiService.addRouteLoading();
    const contractConcession = new ContractConcession(
      this.contractConcessionForm.value
    );
    contractConcession.startDate = this.contractConcessionForm.controls.startDate.value ? moment(this.contractConcessionForm.controls.startDate.value).format('YYYY-MM-DD') : null;

    // this.uiService.removeRouteLoading();
    // return false;
    this.contractConcessionService.createOrUpdateContractConcession(contractConcession).subscribe(data => {
      this.uiService.removeRouteLoading();
      if (this.dialogRef) {
        this.dialogRef.close(true);
      }
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    });
  }
  onCancel() {
    this.dialogRef.close(false);
  }

  isRequiredField(field: string) {
    const form_field = <AbstractControl>this.contractConcessionForm.get(field);
    if (!form_field.validator) {
      return false;
    }

    const validator = form_field.validator({} as AbstractControl);
    return (validator && validator.required);
  }

}
